import { Component } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
    selector: 'app-notfound',
    templateUrl: './app.notfound.component.html',
    standalone: false
})
export class AppNotfoundComponent {
    constructor(public app: AppComponent) {}
}
